import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { AppService } from '../../../../../../services';
import { PersonDialog } from '../../../../person-dialog';
import { SpecialistSignUpViewerDialogDataService } from '../specialist-sign-up-viewer-dialog-data.service';

@Component({
	selector: 'specialist-sign-up-details-part',
	standalone: true,
	templateUrl: './details.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './details.part.scss'
})
export class SpecialistSignUpDetailsPart {

	private readonly dialogDataService = inject(SpecialistSignUpViewerDialogDataService);
	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly dialog = inject(DialogService);

	public readonly specialistSignUpDetails = computed(() => {
		const details = this.dialogDataService.specialistSignUpDetails();
		if (!details) return undefined;
		return {
			...details,
			trimesterName: this.app.getTrimesterNameById(details.trimesterId),
			formattedCreatedUTC: this.util.date.formatUTC(details.createdUTC!, 'MM/DD/YYYY', 'No Time', 'en-US'),
		};
	});

	public async openPersonDialog(personId: number) {
		await this.dialog.showCustom(PersonDialog, { data: { personId, toEdit: false } }, 800, 800);
	}

}